var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkylink = function SvgSkylink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.5 1.25c-2.5 0-5 .313-5 2.5v5.938a2.19 2.19 0 0 0 2.188 2.187l-.938.938v.312h1.394l1.25-1.25H8.75l1.25 1.25h1.25v-.313l-.938-.937A2.19 2.19 0 0 0 12.5 9.687V3.75c0-2.188-2.238-2.5-5-2.5zm-2.813 9.375a.936.936 0 0 1-.937-.938c0-.518.419-.937.938-.937.518 0 .937.419.937.938a.936.936 0 0 1-.938.937zM3.75 6.25h3.125v-2.5H3.75v2.5zm4.375 0v-2.5h3.125v2.5H8.125zm1.25 3.438c0 .518.419.937.938.937a.936.936 0 0 0 .937-.938.936.936 0 0 0-.938-.937.936.936 0 0 0-.937.938z"
  }))));
};
export default SvgSkylink;